import { useSelector } from 'react-redux'
import { selectCompanyPlan } from 'src/selectors/company.selector'
import { useMemo } from 'react'
import { PlanEnum } from 'src/enums/planTypes'

interface PermissionPlanResponse {
  inventory: boolean
  pricingPolicies: boolean
  presentation: boolean
  recipes: boolean
}

const LIMITED_PLANS = [PlanEnum.FREE, PlanEnum.ESENCIAL]

export const usePermissionFromPlan = (): PermissionPlanResponse => {
  const plan: number = useSelector(selectCompanyPlan)

  const limited: boolean = useMemo(() => LIMITED_PLANS.some(p => p === plan), [plan])

  return {
    inventory: !limited,
    pricingPolicies: !limited,
    presentation: !limited,
    recipes: !limited,
  }
}
